"use client";

import React from "react";
import { Box, Heading } from "@radix-ui/themes";
import styles from "./PageIndexPage.module.scss";
import { PageIndexItem } from "./PageIndexPageClient";
import PageSearchResult from "../SearchPage/PageSearchResult";

type PageIndexListProps = {
  items: PageIndexItem[];
};

export default function PageIndexList({ items }: PageIndexListProps) {
  if (items.length === 0) {
    return null;
  }

  const elements: React.ReactNode[] = [];
  let previousLetter: string | null = null;

  items.forEach((item, index) => {
    const firstChar = item.title.charAt(0).toUpperCase();
    const firstLetter = /[A-Z]/.test(firstChar) ? firstChar : "#";

    if (firstLetter !== previousLetter) {
      elements.push(
        <Box
          asChild
          key={`header-${firstLetter}`}
          className={styles.letterHeader}
        >
          <li>
            <Heading
              as="h2"
              size="5"
              weight="bold"
              id={`letter-${firstLetter}`}
            >
              {firstLetter}
            </Heading>
          </li>
        </Box>,
      );
      previousLetter = firstLetter;
    }

    elements.push(
      <PageSearchResult
        key={item.id || index}
        id={item.id}
        title={item.title}
        url={item.url}
        breadcrumbs={item.breadcrumbs}
        content=""
      />,
    );
  });

  return (
    <Box asChild className={styles.list}>
      <ul>{elements}</ul>
    </Box>
  );
}
